import React, {useEffect} from "react";
import {matchPath} from "react-router";
import {routes, routesLists} from "../../../../../core/models/static/routes/app-routes";
import {Redirect, Route, Switch, useHistory, useLocation} from "react-router-dom";
import ProductsListView from "./list";
import ProductInformationView from "./single";
import ProductRelationTypesView from "./relation-types";
import ManageSuggestionsView from "./manage-suggestions";
import TagManagementViews from "./tag-management";
import PriceBulkChangeViews from "./price-bulk-change";
import AccessDeniedView from "../../../error/access-denied";
import ServerErrorView from "../../../error/server-error";
import CategoryManagementView from "./category-management";
import ProductCodeTypesView from "./code-types";
import useAccessLevels from "../../../../hooks/use-access-levels";
import ProductSharingRulesView from "./product-sharing-rules";
import FastConnectionView from "./fast-connection";
import ManageProductPropertiesView from "./manage-product-properties";


const ProductsView = () => {
    const operatorAccessLevels = useAccessLevels();
    const location = useLocation();
    const history = useHistory();


    /**
     * Listens for the changes in the url and which each change
     * if the url is the same as /products, changes it immediately to the /products/list
     */
    useEffect(() => {
        if (!!matchPath(location.pathname, {path: routes.products.base, exact: true})) {
            if (operatorAccessLevels.packages.lookup.products) {
                history.replace(routes.products.list);
            } else if (operatorAccessLevels.packages.lookup.manageTags) {
                history.replace(routes.products.tags.list);
            } else if (operatorAccessLevels.packages.lookup.manageRelationTypes) {
                history.replace(routes.products.relationTypes);
            } else if (operatorAccessLevels.packages.lookup.manageCategories) {
                history.replace(routes.products.categoryManagement);
            } else if (operatorAccessLevels.packages.lookup.manageSharingRules) {
                history.replace(routes.products.shareRules);
            } else if (operatorAccessLevels.packages.lookup.manageProductProperties) {
                history.replace(routes.products.manageProperties);
            } else if (operatorAccessLevels.packages.lookup.fastConnection) {
                history.replace(routes.products.productFastConnection);
            } else if (operatorAccessLevels.packages.lookup.bulkPriceChanges) {
                history.replace(routes.products.bulkPriceChange.dashboard);
            } else if (
                operatorAccessLevels.packages.lookup.technicalSuggestionsList ||
                operatorAccessLevels.packages.lookup.applicationSuggestionsList
            ) {
                history.replace(routes.products.manageSuggestions.base);
            } else {
                history.replace(routes.products.base.concat(routes.error.accessDeniedForSection));
            }
        }
    }, [history, location.pathname, operatorAccessLevels.packages.lookup.applicationSuggestionsList, operatorAccessLevels.packages.lookup.fastConnection, operatorAccessLevels.packages.lookup.manageRelationTypes, operatorAccessLevels.packages.lookup.products, operatorAccessLevels.packages.lookup.manageTags, operatorAccessLevels.packages.lookup.technicalSuggestionsList, operatorAccessLevels.packages.lookup.bulkPriceChanges, operatorAccessLevels.packages.lookup.manageCategories, operatorAccessLevels.packages.lookup.manageSharingRules, operatorAccessLevels.packages.lookup.manageProductProperties])

    return (
        <Switch>
            <Route path={routes.products.base} exact/>
            {
                operatorAccessLevels.packages.lookup.products &&
                <Route path={routes.products.list} exact>
                    <ProductsListView/>
                </Route>
            }
            <Route path={routes.products.list.concat(routes.error.accessDeniedForSection)} exact>
                <AccessDeniedView/>
            </Route>
            <Route path={routes.products.list.concat(routes.error.serverErrorForSection)} exact>
                <ServerErrorView/>
            </Route>
            {
                operatorAccessLevels.packages.lookup.manageTags &&
                <Route path={[
                    routes.products.tags.list,
                    routes.products.tags.single,
                ]} exact>
                    <TagManagementViews/>
                </Route>
            }
            <Route path={routesLists.productManageSuggestions} exact>
                <ManageSuggestionsView/>
            </Route>
            <Redirect
                from={routes.products.manageSuggestions.base.concat(routes.error.accessDeniedForSection)}
                to={routes.products.base.concat(routes.error.accessDeniedForSection)}
            />
            {
                operatorAccessLevels.packages.lookup.manageRelationTypes &&
                <Route path={routes.products.relationTypes} exact>
                    <ProductRelationTypesView/>
                </Route>
            }
            {
                operatorAccessLevels.packages.lookup.manageCodeTypes &&
                <Route path={routes.products.codeTypes} exact>
                    <ProductCodeTypesView/>
                </Route>
            }
            {
                operatorAccessLevels.packages.lookup.productInformation &&
                <Route path={routes.products.single} exact>
                    <ProductInformationView/>
                </Route>
            }
            <Route path={routes.products.codeTypes} exact>
                <ProductCodeTypesView/>
            </Route>
            {
                operatorAccessLevels.packages.lookup.manageSharingRules &&
                <Route path={routes.products.shareRules} exact>
                    <ProductSharingRulesView/>
                </Route>
            }
            {
                operatorAccessLevels.packages.lookup.manageProductProperties &&
                <Route path={routes.products.manageProperties} exact>
                    <ManageProductPropertiesView/>
                </Route>
            }
            {
                operatorAccessLevels.packages.lookup.fastConnection &&
                <Route path={routes.products.productFastConnection} exact>
                    <FastConnectionView/>
                </Route>
            }
            {
                operatorAccessLevels.packages.lookup.bulkPriceChanges &&
                <Route path={routesLists.bulkPriceChange} exact>
                    <PriceBulkChangeViews/>
                </Route>
            }
            {
                operatorAccessLevels.packages.lookup.manageCategories &&
                <Route path={routes.products.categoryManagement} exact>
                    <CategoryManagementView/>
                </Route>
            }
            <Redirect to={routes.products.base.concat(routes.error.accessDeniedForSection)}/>
        </Switch>
    );
};

export default ProductsView;
